/** 外車綁定／修改資料共用表單（車號、姓名、手機、公司名） */
import React, { useState } from 'react'
import { Alert, Box, Button, CircularProgress, TextField } from '@mui/material'
import type { ExtBindRequest, ExtDriver } from './types'

interface Props {
  initial?: ExtDriver | null
  submitLabel: string
  onSubmit: (req: ExtBindRequest) => Promise<void>
}

const ExtDriverForm: React.FC<Props> = ({ initial, submitLabel, onSubmit }) => {
  const [trailerNo, setTrailerNo] = useState(initial?.trailerNo ?? '')
  const [driverName, setDriverName] = useState(initial?.driverName ?? '')
  const [mobile, setMobile] = useState(initial?.mobile ?? '')
  const [companyName, setCompanyName] = useState(initial?.companyName ?? '')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    const t = trailerNo.trim()
    if (!t) return setError('請輸入車號')
    if (!/^[A-Za-z0-9\s-]{2,12}$/.test(t)) return setError('車號只能是英數字，例如 ABC-1234')
    if (!driverName.trim()) return setError('請輸入姓名')
    if (mobile.trim() && !/^09\d{8}$/.test(mobile.trim())) return setError('手機需為 09 開頭 10 碼')
    setLoading(true)
    try {
      await onSubmit({
        trailerNo: t,
        driverName: driverName.trim(),
        mobile: mobile.trim() || undefined,
        companyName: companyName.trim() || undefined,
      })
    } catch (err) {
      setError(err instanceof Error ? err.message : '送出失敗，請稍後再試')
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <TextField fullWidth required label="車號" placeholder="例：ABC-1234" value={trailerNo}
        onChange={(e) => setTrailerNo(e.target.value.toUpperCase())} sx={{ mb: 2 }}
        inputProps={{ autoCapitalize: 'characters', maxLength: 12 }} />
      <TextField fullWidth required label="姓名" value={driverName} onChange={(e) => setDriverName(e.target.value)} sx={{ mb: 2 }}
        inputProps={{ maxLength: 50 }} />
      <TextField fullWidth label="手機（選填）" value={mobile} onChange={(e) => setMobile(e.target.value)} sx={{ mb: 2 }}
        inputProps={{ inputMode: 'numeric', maxLength: 10 }} />
      <TextField fullWidth label="公司（選填）" value={companyName} onChange={(e) => setCompanyName(e.target.value)} sx={{ mb: 3 }}
        inputProps={{ maxLength: 100 }} />
      <Button fullWidth type="submit" variant="contained" size="large" disabled={loading}
        sx={{ backgroundColor: '#4caf50', fontWeight: 700, py: 1.5, '&:hover': { backgroundColor: '#388e3c' } }}>
        {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : submitLabel}
      </Button>
      <Box sx={{ mt: 2 }} />
    </form>
  )
}

export default ExtDriverForm
